import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9fa6b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReleaseSupply" }
const _hoisted_2 = {
  key: 1,
  class: "distinguish"
}
const _hoisted_3 = { class: "textWarpper" }
const _hoisted_4 = { class: "btnWarpper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下一步")
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = { class: "case" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "案例", -1))
const _hoisted_9 = { class: "caseItem" }
const _hoisted_10 = { class: "user" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "发布单品种供应：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "供苗品种：苹果树 供苗数量：1000株 供苗规格：1.5米 供苗地点：北京市朝阳区", -1))
const _hoisted_13 = {
  key: 2,
  class: "form"
}
const _hoisted_14 = { class: "uploadWarpper" }
const _hoisted_15 = {
  class: "uploadWarpper",
  style: {"margin-top":"12px"}
}
const _hoisted_16 = {
  key: 0,
  class: "imgView"
}
const _hoisted_17 = { class: "inputWarpper" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("普通")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("精品")
const _hoisted_21 = { class: "inputWarpper" }
const _hoisted_22 = { class: "priceWarpper" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "0表示"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("面议")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1))
const _hoisted_26 = { class: "priceWarpper" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "0表示"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("面议")
], -1))
const _hoisted_29 = { class: "specifications" }
const _hoisted_30 = { class: "specificationsItem" }
const _hoisted_31 = {
  key: 0,
  class: "specificationsRange"
}
const _hoisted_32 = ["placeholder", "onUpdate:modelValue", "onInput"]
const _hoisted_33 = { class: "tips" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1))
const _hoisted_35 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_36 = {
  key: 1,
  class: "specificationsInput"
}
const _hoisted_37 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_38 = {
  key: 2,
  class: "specificationsSelect"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "actions" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_VanRadio = _resolveComponent("VanRadio")!
  const _component_VanRadioGroup = _resolveComponent("VanRadioGroup")!
  const _component_VanPicker = _resolveComponent("VanPicker")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.video)
      ? (_openBlock(), _createBlock(_component_VideoPlayer, {
          key: 0,
          class: "video",
          src: $setup.video,
          autoplay: "",
          loop: "",
          language: "zh"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    ($setup.stepActive == 0 && !$setup.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VanField, {
              rows: "5",
              autosize: "",
              type: "textarea",
              placeholder: $setup.text,
              modelValue: $setup.textValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.textValue) = $event))
            }, null, 8, ["placeholder", "modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_VanButton, {
                type: "primary",
                color: "#FEC64B",
                size: "small",
                onClick: $setup.parseText
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(`注意事项：（信息越完善越有利于采购方联系您）\n\n信息中请包含以下内容会自动识别: \n1.供应品种\n2.供应数量 \n3.相关规格 4.供苗地点`), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_VanImage, {
                  src: "https://img.yzcdn.cn/vant/cat.jpeg",
                  width: "30",
                  height: "30",
                  fit: "cover",
                  round: ""
                }),
                _hoisted_11
              ]),
              _hoisted_12
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.stepActive == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: `item${idx}`
            }, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (img, imgIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "imgView",
                    key: `img${imgIdx}`
                  }, [
                    _createVNode(_component_VanImage, {
                      src: img.img,
                      width: "72px",
                      height: "72px"
                    }, null, 8, ["src"]),
                    _createVNode(_component_VanIcon, {
                      name: "close",
                      size: "18",
                      onClick: ($event: any) => ($setup.deleteImg(idx,imgIdx))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128)),
                _createVNode($setup["Upload"], {
                  class: "upload",
                  accept: "image/*",
                  "max-count": "6",
                  multiple: "",
                  "after-read": $setup.imgAfterRead,
                  onClickUpload: ($event: any) => ($setup.uploadIndex = idx)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/uploadImage.png")
                    }, null, 8, ["src"])
                  ]),
                  _: 2
                }, 1032, ["onClickUpload"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                ($setup.videoImg[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_VanImage, {
                        src: $setup.videoImg[0].img,
                        width: "72px",
                        height: "72px",
                        onLoad: $setup.videoImgLoad
                      }, null, 8, ["src"]),
                      _createVNode(_component_VanIcon, {
                        name: "close",
                        size: "18",
                        onClick: ($event: any) => ($setup.deleteVideo(idx))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_van_uploader, {
                  class: "upload",
                  accept: "video/*",
                  "after-read": $setup.videoAfterRead,
                  "max-count": "1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/uploadVideo.png")
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, !$setup.videoImg[0]]
                ])
              ]),
              _createVNode(_component_VanField, {
                label: "品种",
                readonly: "",
                "is-link": "",
                modelValue: item.name,
                "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                "input-align": "right",
                border: false,
                required: "",
                onClick: ($event: any) => {$setup.isSelectSearch = true;$setup.selectVarietiesIndex = idx}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
              _createVNode(_component_VanField, {
                label: "数量",
                placeholder: "请输入品种",
                border: false,
                "input-align": "right",
                required: ""
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      placeholder: "数量",
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].quantity) = $event)
                    }, null, 8, _hoisted_18), [
                      [_vModelText, $setup.dataList[idx].quantity]
                    ]),
                    _createVNode(_component_VanRadioGroup, {
                      class: "radio",
                      size: "small",
                      direction: "horizontal",
                      modelValue: $setup.dataList[idx].quality,
                      "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].quality) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_VanRadio, {
                          name: "0",
                          shape: "square",
                          checkedColor: "#FEC64B"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_VanRadio, {
                          name: "2",
                          shape: "square",
                          checkedColor: "#FEC64B"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_VanField, {
                label: "单价",
                placeholder: "请输入品种",
                border: false,
                "input-align": "right"
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "最低价格",
                        "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].minPrice) = $event)
                      }, null, 8, _hoisted_23), [
                        [_vModelText, $setup.dataList[idx].minPrice]
                      ]),
                      _hoisted_24
                    ]),
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "最高价格",
                        "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].maxPrice) = $event)
                      }, null, 8, _hoisted_27), [
                        [_vModelText, $setup.dataList[idx].maxPrice]
                      ]),
                      _hoisted_28
                    ])
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_VanField, {
                label: "地区",
                "is-link": "",
                modelValue: $setup.dataList[idx].address || "请选择地址",
                readonly: "",
                required: "",
                border: false,
                "input-align": "right",
                onClick: ($event: any) => {$setup.isShowCityPicker = true;$setup.cityPickerIndex = idx}
              }, null, 8, ["modelValue", "onClick"]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list[$setup.specificationsIndex].attributeObject, (inputItem, itemIdx) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_VanField, {
                      label: inputItem.name,
                      border: false,
                      "input-align": "right"
                    }, {
                      input: _withCtx(() => [
                        (inputItem.attributeType=="range")
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _withDirectives(_createElementVNode("input", {
                                placeholder: `${inputItem.name}最小`,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.data[itemIdx].value[0]) = $event),
                                onInput: ($event: any) => ($setup.minChange(idx,itemIdx))
                              }, null, 40, _hoisted_32), [
                                [_vModelText, item.data[itemIdx].value[0]]
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", null, _toDisplayString(inputItem.unit), 1)
                              ]),
                              _hoisted_34,
                              _withDirectives(_createElementVNode("input", {
                                placeholder: `${inputItem.name}最大`,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.data[itemIdx].value[1]) = $event)
                              }, null, 8, _hoisted_35), [
                                [_vModelText, item.data[itemIdx].value[1]]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(inputItem.unit), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (inputItem.attributeType=="input")
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                placeholder: `请输入${inputItem.name}`,
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.data[itemIdx].value) = $event)
                              }, null, 8, _hoisted_37), [
                                [_vModelText, item.data[itemIdx].value]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (inputItem.attributeType=="select")
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", {
                                class: "select",
                                onClick: ($event: any) => {$setup.isPickerShow = true;$setup.pickerListIdx=idx;$setup.pickerIdx = itemIdx}
                              }, _toDisplayString(item.data[itemIdx].value||'请选择'), 9, _hoisted_39)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]))
                }), 256))
              ]),
              _createVNode(_component_VanField, {
                class: "textArea",
                rows: "2",
                autosize: "",
                type: "textarea",
                modelValue: $setup.dataList[idx].profile,
                "onUpdate:modelValue": ($event: any) => (($setup.dataList[idx].profile) = $event),
                placeholder: "请输入备注"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_VanButton, { size: "small" }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                }),
                _createVNode(_component_VanButton, {
                  type: "primary",
                  color: "#FEC64B",
                  size: "small",
                  onClick: ($event: any) => ($setup.onsubmit(idx)),
                  disabled: item.isRelease,
                  loading: $setup.submitLoading,
                  "loading-text": "正在发布..."
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.id?'保存修改':item.isRelease?'已发布':'发布该供应'), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled", "loading"])
              ])
            ]))
          }), 128)),
          _createVNode($setup["CityPicker"], {
            modelValue: $setup.isShowCityPicker,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowCityPicker) = $event)),
            onConfirm: $setup.confirmCity
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["VarietiesSearch"], {
      show: $setup.isSelectSearch,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.isSelectSearch) = $event)),
      onConfirm: $setup.confirmVarieties
    }, null, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      show: $setup.isPickerShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.isPickerShow) = $event)),
      style: {"width":"100vw"},
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanPicker, {
          title: "种植状态",
          columns: $setup.pickerColumns($setup.list[$setup.pickerListIdx].attributeObject[$setup.pickerIdx].options),
          onConfirm: $setup.confirmPicker,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => ($setup.isPickerShow = false))
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}